import styled from 'styled-components';

import colors from 'utils/colors';

import { MenuColumnTheme } from '../../interfaces';

export const MenuColumn = styled.div<{ colorScheme: MenuColumnTheme; isActive: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 0;
  background-color: ${props => {
    const { isActive, colorScheme } = props;
    if (!isActive) {
      return colors.darkGrey;
    }
    switch (colorScheme) {
      case MenuColumnTheme.BLUE_GREY:
        return colors.blueGrey;
      case MenuColumnTheme.BLUE_GREY_75:
        return colors.blueGrey75;
      case MenuColumnTheme.DARK_GREY:
      default:
        return colors.darkGrey;
    }
  }};
`;
